import { render, staticRenderFns } from "./AppDialogShell.vue?vue&type=template&id=7cb874dc&scoped=true&lang=pug"
import script from "./AppDialogShell.vue?vue&type=script&lang=js"
export * from "./AppDialogShell.vue?vue&type=script&lang=js"
import style0 from "./AppDialogShell.vue?vue&type=style&index=0&id=7cb874dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb874dc",
  null
  
)

export default component.exports